import { useEffect, useRef } from 'react';
import { ModalUI } from 'sonata-react-components';

import { GroupingPortal } from './GroupingPortal';

import './groupingModal.scss';

import type { ReactNode } from 'react';

interface ModalHandler {
  closeModal: () => void;
  openModal: () => void;
}

export interface GroupingModalProps {
  children: ReactNode;
  /** Hides the header close button (e.g. while a change is being applied). Defaults to `false`. */
  closeDisabled?: boolean;
  description?: string;
  id: string;
  /** Footer content on the left (Cancel, Delete group...). */
  leftButton: ReactNode;
  onClose: () => void;
  rightButton: ReactNode;
  title: string;
}

/** Shell shared by every grouping modal: portal, light theme, centered title and footer buttons. */
export function GroupingModal({
  children,
  closeDisabled = false,
  description,
  id,
  leftButton,
  onClose,
  rightButton,
  title
}: Readonly<GroupingModalProps>) {
  const modalRef = useRef<ModalHandler | null>(null);

  useEffect(() => {
    modalRef.current?.openModal();
  }, []);

  return (
    <GroupingPortal>
      <ModalUI
        centeredTitleDescription
        className="groupingModal"
        closeModalCallback={onClose}
        description={description}
        hideCloseButton={closeDisabled}
        id={id}
        leftButton={leftButton}
        ref={modalRef}
        rightButton={rightButton}
        title={title}
        width="572px"
      >
        <div className="groupingModal__body">{children}</div>
      </ModalUI>
    </GroupingPortal>
  );
}
